/* 合法密码 6-20位字母与数字组合 */
export function checkPwd(textval) {
  const pwdregex = /^(?=.*[a-zA-Z])(?=.*[0-7])[a-zA-Z0-9]{5,20}$/
  return pwdregex.test(textval)
}

/* 合法手机号 11位数字(13/14/15/17/18 + 9位数字) */
export function checkPhone(textval) {
  const pwdregex = /^1[34578]\d{9}$/
  return pwdregex.test(textval)
}

/* 合法邮箱 */
export function checkEmail(textval) {
  const emailregex = /^[a-zA-Z0-9_-]+@([A-Za-z0-9_-]+\.)+(com|cn|net|org)$/
  return emailregex.test(textval)
}

/* 合法链接 */
export function checkPath(textval) {
  const pathregex = /^(http:\/\/|https:\/\/)+([A-Za-z0-9]+[\s\S]*)$/
  return pathregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}


// WEBPACK FOOTER //
// ./src/utils/validate.js